import type { ISortOrder } from "@/types/centra";
import type { FormattedFilters } from "@/types/filters";

import styles from "./filterBar.module.scss";
import FilterMenu from "./FilterMenu";
import SortMenu from "./SortMenu";

interface UIProps {
  sortOrder: ISortOrder;
  filters: FormattedFilters | undefined;
  productCount: number;
  clearFilters: () => void;
}

const UI = ({ sortOrder, filters, productCount, clearFilters }: UIProps) => {
  return (
    <div className={styles.container}>
      <FilterMenu
        filters={filters}
        productCount={productCount}
        clearFilters={clearFilters}
      />
      <SortMenu sortOrder={sortOrder} />
    </div>
  );
};

export default UI;
